import { createReducer, on } from '@ngrx/store';
import { OrganizationApiKeysState } from '../../models/organizations/apikeys.model';
import * as OrganizationsActions from '../../actions/organizations/apikeys.actions';
import * as AuthActions from '../../actions/auth.actions';

export const initialOrganizationApiKeysState: OrganizationApiKeysState = {
  apiKeysByOrgId: {}
};

export const organizationApiKeysReducer = createReducer(
  initialOrganizationApiKeysState,

  on(OrganizationsActions.loadOrganizationApiKeysSuccess, (state, { organizationId, apiKeys }) => ({
    ...state,
    apiKeysByOrgId: {
      ...state.apiKeysByOrgId,
      [organizationId]: apiKeys
    }
  })),

  on(OrganizationsActions.createOrganizationApiKeySuccess, (state, { organizationId, apiKey }) => {
    const prev = state.apiKeysByOrgId?.[organizationId] || [];
    return {
      ...state,
      apiKeysByOrgId: {
        ...state.apiKeysByOrgId,
        [organizationId]: [...prev, apiKey]
      }
    };
  }),

  on(OrganizationsActions.deleteOrganizationApiKeySuccess, (state, { organizationId, apiKeyId }) => {
    const prev = state.apiKeysByOrgId?.[organizationId] || [];
    return {
      ...state,
      apiKeysByOrgId: {
        ...state.apiKeysByOrgId,
        [organizationId]: prev.filter(key => key.id !== apiKeyId)
      }
    };
  }),

  on(OrganizationsActions.updateOrganizationApiKeySuccess, (state, { organizationId, apiKey }) => ({
    ...state,
    apiKeysByOrgId: {
      ...state.apiKeysByOrgId,
      [organizationId]: (state.apiKeysByOrgId?.[organizationId] || [])
        .map(key => key.id === apiKey.id ? apiKey : key)
    }
  })),

  // Reset organization API keys state on logout or clearUserData
  on(AuthActions.logout, AuthActions.clearUserData, () => initialOrganizationApiKeysState)
);
